/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class UserApi {
    static getInstance() {
        if (!this.instance) this.instance = new UserApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取用户列表
    async getUserList (param,num,size){
        let url = `/api/v1/page/users/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增用户
    async addUser (param){
        let url = `/api/v1/page/users`
        let result = await this.getData(url,param,'POST')
        return result
    }

     // 用户修改头像
     async editAvatar (param,id){
        let url = `/api/v1/page/users/${id}/avatar`
        let result = await this.getData(url,param,'POST','multipart/form-data')
        return result
    }

    // 获取用户信息
    async getUserInfo (id){
        let url = `/api/v1/page/users/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 禁用/启用用户
    async changeUserStatus (param, id){
        let url = `/api/v1/page/users/${id}/${param.status}`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 管理员修改用户密码
    async editPasswordByAdmin (param,id){
        let url = `/api/v1/page/users/${id}/reset/pwd`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 用户自己修改密码
    async editPasswordByUser (param,id){
        let url = `/api/v1/page/users/${id}/update/pwd`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取客户列表
    async getCustomerList (param){
        let url = `/api/v1/page/dict/query`
        let result = await this.getData(url,param,'POST')
        return result
    }
}

export {
    UserApi
}